import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import "./index.scss";

import {
  getAddress,
  getAddressSuggestions,
  createLocationModel,
  getLocationByLocationModel,
  locationIsEmpty,
  isSameLocations,
  fillLocationFromPlace,
  getRestaurantCityList,
  getLocationByString,
  getPreviousAddresses,
  getLocationByAddress
} from "../../../services/order";
import {
  SHOW_DROPDOWN_NAME,
  MODEL_TYPE,
  FIND_ADDRESS_TYPE_ACTION,
  TYPE_MARKER
} from "../../../utils/enums";
import Markers from "../../../services/markers";
import { isSameObjects } from "../../../utils/objects-util";
import { getMapRegionsFiltered } from "../../../services/filter";
import { getDefaultGoogleLatLngBounds, getGoogleLatLngRegion } from "../../../services/restaurant";

import FindAddress from "../FindAddress";
import { getInitModel } from "../../../services/initModels";
import PortalServiceMap from "../PortalMap";

const KM_IN_LAT_DEGREE = 110.574;
const KM_IN_LNG_DEGREE = 111.320;
const MIN_FIT_RADIUS_KM = 1;

class MapAddressControl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchAddress: "",
      getSuggested: false,
      suggestedAddresses: [],
      previousAddresses: [],
      markers: [],
      showDropDownName: null,
      cityList: [],
      center: null,
      boundsLocations: []
    };

    this.lastSuggestedAddress = "";
    this.lastSearchAddress = "";
  }

  componentDidMount() {
    this.initData();
  }

  componentDidUpdate(prevProps, prevState) {
    const { suggestedAddresses, previousAddresses } = this.state;
    const { value, restaurant, item, depotId } = this.props;

    this.updateSearchParamsFromProps(prevProps, prevState);
    if (value !== prevProps.value ||
      suggestedAddresses !== prevState.suggestedAddresses ||
      previousAddresses !== prevState.previousAddresses
    ) {
      this.updateAddressMarker();
    }

    if (restaurant !== prevProps.restaurant ||
      depotId !== prevProps.depotId ||
      (item || {}).depotId !== (prevProps.item || {}).depotId ||
      locationIsEmpty(this.state.center, true)
    ) {
      this.updateRegionsCenter();
    }
  }

  initData = () => {
    const { suggestedAddresses } = this.state;
    const { restaurant } = this.props;
    const searchAddress = suggestedAddresses.length
      ? suggestedAddresses[0].address.street
      : this.state.searchAddress;

    const boundsLocations = this.getBoundsLocations();
    const regionsCenter = this.getCenterByLocations(boundsLocations);

    this.lastSuggestedAddress = searchAddress;
    this.setState({
      cityList: getRestaurantCityList(restaurant),
      searchAddress: searchAddress,
      showDropDownName: suggestedAddresses.length
        ? SHOW_DROPDOWN_NAME.suggest
        : false,
      markers: this.getInitMarkers(),
      center: regionsCenter || this.state.center,
      boundsLocations: regionsCenter ? this.getFitLocations(boundsLocations) : []
    }, () => this.updateAddressMarker());
  };

  updateSearchParamsFromProps = (prevProps, prevState) => {
    const { searchInfo } = this.props;
    const { showDropDownName } = this.state;

    if (searchInfo !== prevProps.searchInfo) {
      const { searchAddress, typeAction } = searchInfo || {};
      switch (typeAction) {
        case FIND_ADDRESS_TYPE_ACTION.search:
        case FIND_ADDRESS_TYPE_ACTION.find:
        case FIND_ADDRESS_TYPE_ACTION.findByAddress:
          this.setState({ searchAddress: searchAddress }, () =>
            this.getLocation(
              typeAction === FIND_ADDRESS_TYPE_ACTION.find,
              false,
              typeAction === FIND_ADDRESS_TYPE_ACTION.findByAddress
            )
          );
          break;
        case FIND_ADDRESS_TYPE_ACTION.history:
          this.handleOnShowDropdown(SHOW_DROPDOWN_NAME.history);
          if (showDropDownName) {
            this.setState({ showDropDownName: false });
          }
          break;
        case FIND_ADDRESS_TYPE_ACTION.restore:
          this.handleOnChangeSearch(
            prevProps.searchInfo ? prevProps.searchInfo.searchAddress : "",
            searchAddress,
            true
          );
          break;
        default:
          this.setState({ searchAddress: "", showDropDownName: false });
          break;
      }
    }
  };

  setGEOLocationData = data => {
    const { value, onPropChange } = this.props;
    const newAddress = data.locatedAddress;
    const suggestedAddresses = data.suggestedAddresses;

    if (!suggestedAddresses.length && newAddress)
      suggestedAddresses.push(newAddress);

    if (newAddress && newAddress.location) {
      onPropChange({
        address: {
          location: getInitModel(MODEL_TYPE.location, newAddress.location),
          address: getInitModel(MODEL_TYPE.address, {
            ...newAddress.address,
            city: (newAddress.address && newAddress.address.city) || ( value.address && value.address.city)
          })
        }
      });
    }

    this.setState({ suggestedAddresses: suggestedAddresses, markers: this.getInitMarkers() });
  };

  setLocatedAddress = address => {
    const { onPropChange, zoomAfterSet } = this.props;
    if (!address) return;

    onPropChange({ address });
    const newState = {
      searchAddress: (address.address && address.address.street) || "",
      showDropDownName: SHOW_DROPDOWN_NAME.suggest
    };

    if(!locationIsEmpty(address.location)) {
      newState.center = address.location;
      newState.zoom = zoomAfterSet || null;
    }
    
    this.setState(newState);
  };

  getLocation = (isFound, skipChangingDropDown, isByAddress) => {
    const { value, restaurant } = this.props;
    let searchAddress = this.state.searchAddress;

    if (isFound) {
      searchAddress = getAddress(value.address);
      if (!skipChangingDropDown)
        this.setState({ showDropDownName: SHOW_DROPDOWN_NAME.suggest });
    }
    if (searchAddress && (this.lastSearchAddress !== searchAddress || isByAddress)) {
      this.lastSuggestedAddress = "";
      this.lastSearchAddress = searchAddress;
      this.setState({ getSuggested: true, searchAddress: searchAddress }, () => {
        const cities = getRestaurantCityList(restaurant);
        const findAction = isByAddress
          ? getLocationByAddress
          : getLocationByString;
        findAction(isByAddress
            ? { ...value.address, city: (value.address && value.address.city) || (cities[0] && cities[0].city) }
            : searchAddress,
          true
        )
        .then(result => this.setGEOLocationData(result), () => this.setState({ suggestedAddresses: [] }))
        .finally(() => {
          this.setState({ getSuggested: false });
          if (!skipChangingDropDown)
            this.setState({ showDropDownName: SHOW_DROPDOWN_NAME.suggest });
        });
      });
    }
  };

  getPrevAddresses = phone => {
    getPreviousAddresses(phone, this.state.lastPhone).then(data => {
      this.setState({
        markers: this.getInitMarkers(),
        lastPhone: data.lastPhone,
        previousAddresses: data.previousAddresses
      });
    });
  };

  getDepotId = () => {
    const { item, depotId } = this.props;
    return depotId ?? (item || {}).depotId;
  };

  isBusinessMenuAsDepot = () => {
    const { restaurant, markerFromMenuAsDepot } = this.props;
    return !!(markerFromMenuAsDepot && restaurant.businessMenu);
  };

  getDepotLocation = () => {
    const { restaurant } = this.props;
    const depotId = this.getDepotId();

    if (this.isBusinessMenuAsDepot()) {
      return restaurant.businessMenu.location || null;
    }

    if (!depotId) return null;

    const depot = (restaurant.depots || []).find(item => item.id === depotId);
    return (depot && depot.address && depot.address.location) || null;
  };

  getBusinessZonesLocations = () => {
    const { restaurant } = this.props;
    const locations = [];

    (((restaurant.businessMenu || {}).delivery_zones) || []).forEach(zone => {
      const data = zone.data || {};
      if (data.circle) {
        locations.push(...this.getCircleZoneLocations(data.circle));
      }
      (data.region || []).forEach(location => locations.push(location));
    });

    return locations;
  };

  getRestaurantRegionsLocations = () => {
    const { restaurant } = this.props;
    const locations = [];

    getMapRegionsFiltered((restaurant.configuration || {}).regions, restaurant.selectedControlCenter)
      .forEach(region => (region.region || []).forEach(location => locations.push(location)));

    return locations;
  };

  getRegionsLocations = () => {
    const { renderPolygonsFromBusiness } = this.props;

    if (renderPolygonsFromBusiness) {
      const businessLocations = this.getBusinessZonesLocations();
      if (businessLocations.length) return businessLocations;
    }

    return this.getRestaurantRegionsLocations();
  };

  getCircleZoneLocations = (circle) => {
    const center = circle.center || circle;
    const radius = circle.radio || 0;

    if (locationIsEmpty(center)) return [];
    if (!radius) return [center];

    return this.getPaddedLocations(center, radius);
  };

  getBoundsLocations = () => {
    const locations = this.getRegionsLocations().filter(location => !locationIsEmpty(location));
    const depotLocation = this.getDepotLocation();

    if (depotLocation && !locationIsEmpty(depotLocation)) {
      locations.push(depotLocation);
    }

    return locations;
  };

  hasBoundsArea = (locations) => {
    const points = (locations || []).map(location =>
      `${location.lat ?? location.latitude},${location.lng ?? location.longitude}`
    );
    return new Set(points).size > 1;
  };

  getFitLocations = (locations) => {
    if (!(locations || []).length) return [];
    if (this.hasBoundsArea(locations)) return locations;

    return this.getPaddedLocations(locations[0], MIN_FIT_RADIUS_KM);
  };

  getPaddedLocations = (location, radius) => {
    const lat = location.lat ?? location.latitude;
    const lng = location.lng ?? location.longitude;

    if (typeof lat !== 'number' || typeof lng !== 'number') return [];

    const latOffset = radius / KM_IN_LAT_DEGREE;
    const lngOffset = radius / (KM_IN_LNG_DEGREE * Math.cos((lat * Math.PI) / 180) || KM_IN_LNG_DEGREE);

    return [
      { lat: lat + latOffset, lng: lng + lngOffset },
      { lat: lat - latOffset, lng: lng - lngOffset }
    ];
  };

  getCenterByLocations = (locations) => {
    const bounds = getDefaultGoogleLatLngBounds();
    if (!bounds) return null;

    let hasLocations = false;
    (locations || []).forEach(location => {
      const latLng = getGoogleLatLngRegion(location);
      if (latLng) {
        bounds.extend(latLng);
        hasLocations = true;
      }
    });

    if (!hasLocations) return null;

    const center = bounds.getCenter();
    return center ? { lat: center.lat(), lng: center.lng() } : null;
  };

  isSameCenter = (center1, center2) => {
    if (!center1 || !center2) return false;
    return (center1.lat ?? center1.latitude) === (center2.lat ?? center2.latitude)
      && (center1.lng ?? center1.longitude) === (center2.lng ?? center2.longitude);
  };

  updateRegionsCenter = () => {
    const boundsLocations = this.getBoundsLocations();
    const fitLocations = this.getFitLocations(boundsLocations);
    const center = this.getCenterByLocations(boundsLocations);
    const newState = {};

    if (!isSameObjects(fitLocations, this.state.boundsLocations)) {
      newState.boundsLocations = fitLocations;
    }

    if (center && !this.isSameCenter(center, this.state.center)) {
      newState.center = center;
    }

    if (Object.keys(newState).length) {
      this.setState(newState);
    }
  };

  getInitMarkers = () => {
    const { restaurant, isOnlyCurrentDepot, markerFromMenuAsDepot, item } = this.props;
    const depotId = this.getDepotId();
    const includedModelTypes = [
      MODEL_TYPE.order,
      MODEL_TYPE.namedPlaces,
      MODEL_TYPE.serviceCities
    ];
    let markers = [];

    if(isOnlyCurrentDepot && (depotId || this.isBusinessMenuAsDepot())) {
      if(markerFromMenuAsDepot && restaurant.businessMenu) {
        markers.push(Markers.instance.createMarker(TYPE_MARKER.depotFromBusiness, restaurant.businessMenu));
      } else {
        const depot = restaurant.depots.find(depot=> depot.id === depotId);
        if(depot) {
          markers.push(Markers.instance.createMarker(TYPE_MARKER.depot, depot));
        }
      }
    } else {
      if(item && includedModelTypes.includes(item.modelType)) {
        markers = Markers.instance.getRestaurantMarkers(restaurant);
      }
    }
    
    return markers;
  };

  suggestAddresses = (address, city) => {
    const { restaurant } = this.props;
    const searchAddress = address || this.state.searchAddress;
    const cityList = getRestaurantCityList(restaurant);

    if (!searchAddress) {
      this.setState({ suggestedAddresses: [], showDropDownName: false });
      return;
    }

    if (this.lastSuggestedAddress === searchAddress) return;
    this.lastSuggestedAddress = searchAddress;

    getAddressSuggestions(
      searchAddress,
      city || cityList[0].city,
      restaurant.countryCode
    ).then(suggestions => {
      this.setState({ suggestedAddresses: suggestions, showDropDownName: SHOW_DROPDOWN_NAME.suggest });
    }, () => this.setState({ suggestedAddresses: [], showDropDownName: false }));
  };

  checkCityList = () => {
    const { value, onCheckCityList } = this.props;
    const { cityList } = this.state;
    const city = value && value.address ? value.address.city : "";

    if (city && cityList) {
      if (!cityList.find(f => f.city === city)) {
        const newCityList = cityList.concat([{ city: city }]);
        this.setState({ cityList: newCityList });
        if (onCheckCityList) {
          onCheckCityList(newCityList);
        }
      }
    }
  };

  updateAddressMarker = () => {
    const { item, originalItem, value } = this.props;
    const { suggestedAddresses, previousAddresses } = this.state;
    const shouldAddMarker = item.modelType === MODEL_TYPE.order ? (item && !item.type) : item;
    let newMarkers = this.getInitMarkers();
    let location = null;    

    if (!!shouldAddMarker) {
      location = value ? value.location : null;
      if (location && !locationIsEmpty(location)) {
        let newMarker = null;
        if (item.modelType === MODEL_TYPE.order) {
          newMarker = Markers.instance.createMarkerByModel(item, true, ((item.address && item.address.placeId) || ""));
        } else {
          newMarker = Markers.instance.createMarkerByModelType(item.modelType, item, true);
        }

        if (newMarker) {
          if (newMarkers.find(f => f.id === newMarker.id)) {
            newMarkers = newMarkers.map(m => (m.id === newMarker.id ? newMarker : m));
          } else {
            newMarkers.push(newMarker);
          }

          this.setState({ center: newMarker.location });
        }
      }
    }

    const suggestedAddressesMarkers = suggestedAddresses.reduce((accumulator, address, index) => {
      const placeId = address && address.address && address.address.placeId;
      let newMarker = Markers.instance.createMarkerByModel(address, false, `${placeId}-${index}`);

      if (!location || (location && !isSameLocations(location, address.location))) {
        if (!locationIsEmpty(address.location) && item.modelType === MODEL_TYPE.order) {
          if (!newMarkers.find(f => f.id === newMarker.id) && !accumulator.find(f=> f.id === newMarker.id)) {
            accumulator.push(newMarker);
          } else {
            newMarkers = newMarkers.map(m => (m.id === newMarker.id ? newMarker : m));
          }
        }
      }

      return accumulator;
    }, []);

    const previousAddressesMarkers = previousAddresses.reduce((accumulator, address, index) => {
      const placeId = address && address.address && address.address.placeId;
      const markerId = `${placeId}-${index}`;
      if (!location ||
        (location && !isSameLocations(location, address.location) && !newMarkers.find(f => f.id === markerId))
      ) {
        if (item.modelType === MODEL_TYPE.order &&
          !locationIsEmpty(address.location) && 
          !accumulator.find(f=> f.id === markerId)
        ) {
            accumulator.push(Markers.instance.createMarkerByModel(address, false, markerId));
        }
      }
      return accumulator;
    }, []);

    newMarkers = newMarkers
      .concat(suggestedAddressesMarkers)
      .concat(previousAddressesMarkers);

    if (item.modelType === MODEL_TYPE.order &&
      originalItem &&
      originalItem.location &&
      !locationIsEmpty(location) &&
      !isSameLocations(location, originalItem.location)
    ) {
      let newMarker = Markers.instance.createMarkerByModel(originalItem, false, "originalMarker");

      if (!locationIsEmpty(newMarker.location)) {
        if (!newMarkers.find(f => f.id === newMarker.id)) {
          newMarkers.push(newMarker);
        } else {
          const existedMarker = newMarkers.filter(f => isSameLocations(f.location, newMarker.location));
          if (!existedMarker || !existedMarker.length) {
            newMarkers.push(newMarker);
          }
        }
      }
    }

    this.setState({ markers: newMarkers }, () => this.checkCityList());
  };

  handleOnShowDropdown = dropdown => {
    const { item } = this.props;
    const { showDropDownName } = this.state;

    if (dropdown === SHOW_DROPDOWN_NAME.suggest) {
      this.setState({ showDropDownName: dropdown }, () => this.getLocation(false, true));
    } else {
      this.setState({ showDropDownName: showDropDownName === dropdown ? false : dropdown });
      if (item && item.modelType === MODEL_TYPE.order && showDropDownName === SHOW_DROPDOWN_NAME.history) {
        this.getPrevAddresses(item.consumerPhone);
      }
    }
  };

  handleOnChangeSearch = (oldVal, newVal, isGeolocate) => {
    const { value } = this.props;
    const { showDropDownName, suggestedAddresses } = this.state;

    this.setState({ searchAddress: newVal }, () => {
      if (newVal !== oldVal) {
        if (
          (!newVal && showDropDownName === SHOW_DROPDOWN_NAME.suggest) ||
          suggestedAddresses.length
        ) {
          this.setState({ showDropDownName: false });
        }
        if (newVal) {
          if (isGeolocate) {
            this.getLocation(true);
          } else {
            this.suggestAddresses(newVal, value.address && value.address.city);
          }
        }
      }
    });
  };

  handleOnAddressSelect = variantAddress => {
    if (variantAddress) {
      if (locationIsEmpty(variantAddress.location)) {
        fillLocationFromPlace(variantAddress.location, variantAddress.address)
          .then(result => this.setLocatedAddress(result));
      } else {
        this.setLocatedAddress(variantAddress);
      }
    }
  };

  handleOnMapClick = clickLocation => {
    const { searchAddress } = this.state;
    const { item, isLocationByPosition, onPropChange } = this.props;
    const location = createLocationModel(clickLocation.lat, clickLocation.lng);

    if (!isLocationByPosition) {
      getLocationByLocationModel(location, false, true).then(result => {
        this.setGEOLocationData(result, location);
        this.lastSuggestedAddress = "";
        this.lastSearchAddress = "";
        this.setState({
          searchAddress: (result.locatedAddress && result.locatedAddress.address && result.locatedAddress.address.street) || searchAddress,
          showDropDownName: SHOW_DROPDOWN_NAME.suggest
        });
      });
    } else {
      getLocationByLocationModel(location, true).then(result => {
          onPropChange({
            address: {
              location,
              address: result.locatedAddress ? result.locatedAddress.address : item.address
            }
          });
          this.setState({
            searchAddress: result.locatedAddress ? result.locatedAddress.address.street : item.address.street
          });
        }, () => {
          onPropChange({ address: { location: location, address: item.address } });
        }
      );
    }
  };

  handleOnMarkerClick = marker => {
    const {handleOnClickMarker} = this.props;

    if(handleOnClickMarker) {
      handleOnClickMarker(marker);
    }

    if (marker.markerType !== TYPE_MARKER.place && marker.markerType !== TYPE_MARKER.depot) {
      this.handleOnAddressSelect({ address: marker.address, location: marker.location });
    }
  };

  render() {
    const {
      searchAddress,
      getSuggested,
      suggestedAddresses,
      previousAddresses,
      showDropDownName,
      markers,
      center,
      zoom,
      boundsLocations,
    } = this.state;
    const { item, value, isHideFindAddress, isHideSearch, isHidePolygon, renderPolygonsFromBusiness, alwaysShowPolygons } = this.props;
    const takeAwayType = item && item.modelType === MODEL_TYPE.order ? !!item.type : false;

    return (
      <div className={classNames("mapAddressControl")}>
        {!isHideFindAddress && (
          <FindAddress
            searchAddress={searchAddress}
            orderAddressLocation={value}
            getSuggested={getSuggested}
            suggestedAddresses={suggestedAddresses}
            previousAddresses={previousAddresses}
            showDropDownName={showDropDownName}
            takeAwayType={takeAwayType}
            isHideSearch={isHideSearch}
            onSelect={this.handleOnAddressSelect}
            onShowDropdown={this.handleOnShowDropdown}
            onChangeSearch={this.handleOnChangeSearch}
          />
        )}
        <PortalServiceMap
          renderPolygonsFromBusiness={renderPolygonsFromBusiness}
          markers={markers}
          center={center}
          zoom={zoom}
          boundsLocations={boundsLocations}
          isHidePolygon={isHidePolygon}
          handleOnMapClick={this.handleOnMapClick}
          onMarkerClick={this.handleOnMarkerClick}
          alwaysShowPolygons={alwaysShowPolygons}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  restaurant: state.restaurant.data
});

export default connect(mapStateToProps)(MapAddressControl);
